import React from 'react';
import { Box, TablePagination, useTheme } from '@mui/material';

/**
 * Reusable Pagination component wrapper around MUI's TablePagination.
 * Styled to fit the application's branding system.
 * 
 * @param {Object} props
 * @param {number} props.count - Total number of records.
 * @param {number} props.page - Current active page (0-indexed).
 * @param {number} props.rowsPerPage - Active rows per page.
 * @param {function} props.onPageChange - Callback function when page changes (event, newPage).
 * @param {function} props.onRowsPerPageChange - Callback function when rows per page changes.
 * @param {Array<number>} [props.rowsPerPageOptions=[10, 20, 50]] - Available rows per page choices.
 */
const Pagination = ({
  count,
  page,
  rowsPerPage = 20,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 20, 50],
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        mt: 2,
        px: 2,
        py: 1,
        bgcolor: '#ffffff',
        borderTop: '1px solid #d0dbe7',
        borderBottomLeftRadius: '0.75rem',
        borderBottomRightRadius: '0.75rem',
        '& .MuiTablePagination-root': {
          color: '#4e7397',
          fontSize: '0.8125rem',
        },
        '& .MuiTablePagination-actions': {
          '& .MuiIconButton-root': {
            color: '#800020',
            '&.Mui-disabled': {
              color: '#d0dbe7',
            },
            '&:hover': {
              bgcolor: 'rgba(128, 0, 32, 0.04)',
            },
          },
        },
        '& .MuiTablePagination-select': {
          fontWeight: 600,
          color: '#0e141b',
        },
      }}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
      />
    </Box>
  );
};

export default Pagination;
